import { gql } from "@apollo/client";

import assessmentQuestionFragment from "@apps/assessments/graphql/assessment-question-fragment";

export default gql`
  ${assessmentQuestionFragment}
  fragment AssessmentGroupFragment on AssessmentGroupNode {
    id
    title
    created
    archived
    isOnlySelfAssessment
    hasNpsQuestions
    assessmentType
    creator {
      id
      name
    }
    canUpdate {
      permission
      reason
    }
    canDelete {
      permission
      reason
    }
    sections {
      edges {
        node {
          id
          title
          description
          questions {
            edges {
              node {
                id
                question {
                  ...AssessmentQuestionFragment
                }
              }
            }
          }
        }
      }
    }
  }
  mutation saveFullAssessmentGroup(
    $title: String
    $assessmentGroupId: Int
    $organizationId: Int
    $assessmentType: AssessmentType
    $sections: [FullAssessmentGroupSectionInput]!
  ) {
    createOrUpdateFullAssessmentGroup(
      organizationId: $organizationId
      assessmentGroupId: $assessmentGroupId
      assessmentType: $assessmentType
      title: $title
      sections: $sections
    ) {
      assessmentGroup {
        ...AssessmentGroupFragment
      }
    }
  }
`;
